import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LegalView from '../views/LegalView.vue'
import { headerOffset } from '@/utils/scroll'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/legal', name: 'legal', component: LegalView },
  { path: '/:pathMatch(.*)*', component: HomeView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      // `top` = décalage sous le bandeau collant
      return { el: to.hash, top: headerOffset(), behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

export default router
